import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";

import api from "../../../services/api";
import { endpoints } from "../../../services/endpoints";

export default function CreateLock() {
  const navigate = useNavigate();

  const [lock, setLock] = useState({
    name: "",
    serialNumber: "",
    companyId: null,
  });

  const [companies, setCompanies] = useState([]);
  const [saving, setSaving] = useState(false);

  // 🔹 Cargar compañías al iniciar
  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(endpoints.companies.list);
        const list = res.data?.data ?? res.data ?? [];
        const formatted = (Array.isArray(list) ? list : []).map((c) => ({
          value: c.id,
          label: c.name,
        }));
        setCompanies(formatted);
      } catch (err) {
        console.error("❌ Error loading companies:", err);
        alert("Error fetching companies");
      }
    })();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLock((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption, { name }) => {
    setLock((prev) => ({
      ...prev,
      [name]: selectedOption ? selectedOption.value : null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);

      const payload = {
        name: lock.name.trim(),
        serialNumber: lock.serialNumber.trim(),
        companyId: lock.companyId,
      };

      await api.post(endpoints.padlock.list, payload, {
        headers: { "Content-Type": "application/json" },
      });

      navigate("/locksadmin");
    } catch (err) {
      console.error(err);
      const r = err?.response;
      const msg =
        Array.isArray(r?.data?.message) ? r.data.message.join("\n") :
        r?.data?.message || r?.data?.error || "Error creating lock";
      alert(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold text-center mb-6">Create Lock</h1>

      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow space-y-4 max-w-lg mx-auto"
      >
        <div>
          <label className="block font-medium">Name</label>
          <input
            type="text"
            name="name"
            value={lock.name}
            onChange={handleChange}
            className="border rounded w-full p-2"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Serial Number</label>
          <input
            type="text"
            name="serialNumber"
            value={lock.serialNumber}
            onChange={handleChange}
            className="border rounded w-full p-2"
            required
          />
        </div>

        <div>
          <label className="block font-medium">Company</label>
          <Select
            options={companies}
            name="companyId"
            onChange={handleSelectChange}
            isClearable
            placeholder="Select a company..."
            value={companies.find((c) => c.value === lock.companyId) || null}
          />
        </div>

        <div className="flex gap-3">
          <button
            type="submit"
            disabled={saving}
            className="bg-blue-600 text-white px-4 py-2 rounded disabled:opacity-60"
          >
            {saving ? "Creating…" : "Create Lock"}
          </button>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="bg-gray-500 text-white px-4 py-2 rounded"
          >
            Cerrar
          </button>
        </div>
      </form>
    </div>
  );
}